(ns frontend.ui.component.lp-portal.report.body.invest-europe.fund.pdf
  (:require
   [frontend.ui.component.lp-portal.report.body.invest-europe.fund.pdf-pages.fund-information :as fund-information]
   [frontend.ui.page.lp-portal.report.pdf.view :as report]))

(defn invest-europe-pages
  [data]
  (concat
   [(fund-information/fund-information-page data)]))

(defn invest-europe-report
  [{:keys [fund-name reporting-period reference-date] :as view-data}]
  (report/report view-data (invest-europe-pages view-data) fund-name reporting-period reference-date))
